/** http/https のみを許可し、javascript: などのスキーム悪用(XSS)を防ぐ */
export const isSafeHttpUrl = (url: string): boolean => {
  try {
    const { protocol } = new URL(url);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
};

/** 1回の表示を識別するID。CTR計測でimpressionとclickを同一表示に紐づけるために使う。 */
export const generateImpressionId = (): string => {
  try {
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.randomUUID === "function"
    ) {
      return crypto.randomUUID();
    }
  } catch {
    // fallthrough
  }
  return `imp-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

/** バナー画像の代替テキスト。遷移先ホストを含め、読み上げで内容を識別できるようにする。 */
export const bannerAltText = (linkUrl: string): string => {
  try {
    return `広告バナー（リンク先: ${new URL(linkUrl).hostname}）`;
  } catch {
    return "広告バナー";
  }
};
